import {ColsNamesEnum} from "../../stay-price-tab/interfaces/cols-names.enum";

export interface IVehicleRentalPriceRow {
    title: string;
    type?: EVehicleRowType;
    total: IVehiclePriceRowPrice;
    collapser?: string;
    collapseGroup?: string;
    isHeaderRow?: boolean;
}

export interface IVehiclePriceRowPrice {
    amount: number;
    currency: string;
}

export enum EVehicleRowType {
    fee = 'fee',
    total = 'total',
    base = 'base',
    service = 'service',
}

export interface IVehicleRentalPriceColsHeaders {
    [ColsNamesEnum.title]: string;
    [ColsNamesEnum.total]: string;
}

